import { useQuery } from '@tanstack/react-query';
import * as userProfileApi from '../../api/userProfile';
import { UserProfileResponse } from '../../api/userProfile';

interface UseUserProfileProps {
  contactId: string;
  organizationId: string;
  enabled?: boolean;
}

/**
 * Hook to fetch user eAlert profile data
 */
export const useUserProfile = ({ contactId, organizationId, enabled = true }: UseUserProfileProps) => {
  return useQuery<UserProfileResponse, Error>({
    queryKey: ['userProfile', contactId, organizationId],
    queryFn: () => userProfileApi.getUserProfile(contactId, organizationId),
    enabled: !!contactId && !!organizationId && enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 2,
  });
};

export type { UserProfileResponse, ContactSavedSearch } from '../../api/userProfile';
